<style scoped>
.step-content {
  position: relative;
}
</style>

<template lang="pug">
div
  ul.row.stepper.linear
    li.step.active
      .step-title.waves-effect Upload Product Spreadsheet
      .step-content
        .row
          .file-field.input-field
            .btn
              span Choose File
              input#products-spreadsheet(
                type='file',
                @change='upload',
                accept='.xlsx'
              )
            .file-path-wrapper
              input#products-spreadsheet-path.file-path.validate(
                type='text',
                :class='sheetValid === false ? "invalid" : ""'
              )
          span.red-text(v-if='sheetValid === false') Selected file contains an invalid format
          div(v-if='productErrors.length')
            p.red-text Error in Products sheet
            ul
              li.red-text(v-for='error in productErrors')
                span.red-text Row {{ error.index + 2 }}: invalid value/s for {{ error.errors.toString() }}
            span.red-text(v-if='productAdditionalErrorsCount > 0') + {{ productAdditionalErrorsCount }} more errors
          div(v-if='variantErrors.length')
            p.red-text Error in Variants sheet
            ul
              li.red-text(v-for='error in variantErrors')
                span.red-text Row {{ error.index + 2 }}: invalid value/s for {{ error.errors.toString() }}
            span.red-text(v-if='variantAdditionalErrorsCount > 0') + {{ variantAdditionalErrorsCount }} more errors
    li.step
      .step-title.waves-effect(
        data-step-label='File names should exactly match variant codes'
      ) Upload Product Photos
      .step-content
        .row
          .file-field.input-field
            .btn
              span Choose Files
              input#products-photos(
                type='file',
                ref='files',
                @change='setPhotos',
                multiple,
                accept='.png, .jpg, .jpeg'
              )
            .file-path-wrapper(style='visibility: hidden')
              input.file-path.validate(
                type='text',
                :class='!!invalidProductPhotos ? "invalid" : ""'
              )
          span.red-text(v-if='!!invalidProductPhotos') Some of the photos provided does not match any variant
          ul
            li(
              v-for='(invalidPhoto, index) in invalidProductPhotos',
              :key='index'
            )
              span.red-text {{ invalidPhoto }}

        .step-actions.row
          .col.s12
            a.waves-effect.waves-dark.btn(
              @click='reviewProducts',
              :class='!photosValid ? "disabled" : ""'
            ) CONTINUE
            a.waves-effect.waves-dark.btn(@click='reviewProducts') Skip
    li.step
      .step-title.waves-effectPasso Review Products
      .step-content
        .row
          .col.s12.l6(
            v-for='(product, index) in queuedProducts',
            :key='product.code'
          )
            app-card-product(
              :product='product',
              :index='index',
              @removeProduct='onRemoveProduct',
              :removable='true'
            )
        .row.center-align(v-if='isLoading')
          .preloader-wrapper.active
            .spinner-layer.spinner-red-only
              .circle-clipper.left
                .circle
              .gap-patch
                .circle
              .circle-clipper.right
                .circle
        .row.step-actions(ref='uploadAction')
          .col.s12
            button.waves-effect.waves-dark.btn.next-step(
              @click='post',
              ref='uploadBtn'
            ) Upload
  .row(v-if='uploading')
    .progress
      .determinate(:style='{ width: uploadPercent + "%" }')
    p.subtitle.small.center-align {{ uploadMessage }} ({{ uploadPercent + "%" }})
  //- pre {{newProducts}}
</template>
<script>
import xlsx from 'xlsx'
import AppCardProduct from '@/components/app-card-product'
import $ from 'jquery'
import Promise from 'bluebird'
import scrollmonitor from 'scrollmonitor'
require('materialize-stepper')
require('materialize-stepper/materialize-stepper.min.css')

export default {
  meta: {
    title: 'Upload Products'
  },
  data () {
    return {
      PAGE_LIMIT: 20,
      currentPage: null,
      totalPage: null,
      productCodes: [],
      isLoading: false,
      uploadMessage: null,
      uploadPercent: 0,
      uploading: false,

      workbook: null,
      sheetValid: null,
      newProducts: null,
      variants: null,
      photos: [],
      invalidProductPhotos: null,
      queuedProducts: null,
      productErrors: [],
      productAdditionalErrorsCount: 0,
      variantErrors: [],
      variantAdditionalErrorsCount: 0,

      files: []
    }
  },
  mounted () {
    $('.stepper').activateStepper({
      linearStepsNavigation: false,
      autoFocusInput: false,
      autoCreateForm: false
    })
  },
  computed: {
    photosValid () {
      return this.photos && !this.invalidProductPhotos
    },
    supplier () {
      // return this.$store.state.profile.supplier
      return 1
    }
  },
  methods: {
    upload (e) {
      const fileReader = new FileReader()
      fileReader.onload = this.onFileLoaded
      fileReader.readAsArrayBuffer(e.target.files[0])
    },
    setPhotos (e) {
      const files = this.$refs.files.files
      this.files = [...this.files, ...files]
      const photos = {}
      this.photos = null
      // this.photos = [..this.photos, ...photos]
      this.invalidProductPhotos = null
      let hasValidPhoto = false
      Array.from(this.files).forEach((photo) => {
        const variantCode = photo.name.replace(/\.[^/.]+$/, '')
        const productCodes = Object.keys(this.newProducts)
        const isValid = productCodes.some((productCode) => {
          return this.variants[productCode].some((variant) => {
            return variant.variantCode === variantCode
          })
        })

        if (!isValid) {
          this.invalidProductPhotos = this.invalidProductPhotos || []
          this.invalidProductPhotos.push(photo.name)
        } else {
          photos[variantCode] = photo
          // this.files[variantCode] = photo
          hasValidPhoto = true
        }
      })

      this.photos = hasValidPhoto ? photos : null
      // this.files = hasValidPhoto ? files : null
    },
    async onFileLoaded (e) {
      const data = new Uint8Array(e.target.result)
      this.workbook = xlsx.read(data, { type: 'array', cellFormula: false })
      this.newProducts = await this.buildProducts()
      this.variants = await this.buildVariants()

      if (!this.productErrors.length && !this.variantErrors.length) {
        $('.stepper').nextStep()
      }
    },
    post () {
      this.uploading = true
      return Promise.resolve()
        .then(this.uploadProducts)
        .then(this.uploadPhotos)
        .then(() => {
          this.uploading = false
          this.$snackbar.success('Products successfully uploaded!')
          this.reset()
        })
    },
    uploadProducts () {
      this.uploadMessage = 'Uploading products'
      this.uploadPercent = 0

      const batchSize = 20
      const productKeys = Object.keys(this.newProducts)
      const batchCount = Math.ceil(productKeys.length / batchSize)

      const batches = []
      for (let i = 0, len = batchCount; i < len; i++) {
        batches.push(
          this.batchPost(productKeys.slice(i * batchSize, (i + 1) * batchSize))
        )
      }

      return Promise.each(batches, (res, index, len) => {
        this.uploadPercent = Math.ceil(((index + 1) / len) * 100)
      })
    },
    batchPost (productKeys) {
      const products = []
      const variants = {}

      productKeys.forEach((key) => {
        products.push(this.newProducts[key])
        variants[key] = this.variants[key]
      })

      return this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return this.$http.post(
          `${this.$config.API_URL}/suppliers/${this.supplier.code}/products`,
          {
            products: products,
            variants: variants
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        )
      })
    },
    testup () {
      return this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        this.$http.post(
          `${this.$config.API_URL}/suppliers/${this.supplier.code}/products/test`,
          {
            sku: '5014218797749'
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        )
      })
    },
    uploadPhotos () {
      this.uploadMessage = 'Uploading photos'
      this.uploadPercent = 0
      const photoKeys = Object.keys(this.photos || {})
      if (!photoKeys.length) {
        return
      }

      const uploads = photoKeys.map((key) => {
        const photo = this.photos[key]
        return this.uploadPhoto(photo)
      })

      return Promise.each(uploads, (res, index, len) => {
        this.uploadPercent = Math.ceil(((index + 1) / len) * 100)
      })
    },
    uploadPhoto (photo) {
      return this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        const data = new FormData()
        data.append('photos', photo)
        return this.$http.post(
          `${this.$config.API_URL}/suppliers/${this.supplier.code}/products/photos`,
          data,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      })
    },
    buildProducts () {
      return Promise.resolve()
        .then(() => {
          if (this.workbook && this.workbook.Sheets['products']) {
            return xlsx.utils.sheet_to_json(this.workbook.Sheets['products'])
          }
        })
        .then((products) => {
          if (!products) {
            return
          }
          const renameKeys = [['product code', 'productCode']]
          const requiredKeys = [
            'productCode',
            'name',
            'category',
            'bottler',
            'country',
            'region',
            'tags'
          ]
          return this.checkAndTransformKeys(products, requiredKeys, renameKeys)
        })
        .then((res) => {
          if (res.errors.length) {
            this.productErrors = res.errors.slice(0, 10)
            this.productAdditionalErrorsCount = res.errors.length - 10
            return null
          } else {
            this.productErrors = []
            this.productAdditionalErrorsCount = 0
            return res.items
          }
        })
        .then((products) => {
          const newProducts = {}
          products.forEach((product) => {
            newProducts[product.productCode] = product
          })
          return newProducts
        })
        .catch()
    },
    buildVariants () {
      return Promise.resolve()
        .then(() => {
          if (this.workbook && this.workbook.Sheets['variants']) {
            return xlsx.utils.sheet_to_json(this.workbook.Sheets['variants'])
          }
        })
        .then((variants) => {
          if (!variants) {
            return
          }

          const renameKeys = [
            ['product code', 'productCode'],
            ['variant code', 'variantCode'],
            ['volume', 'volumeCl'],
            ['alcohol content', 'alcoholContent']
          ]
          const requiredKeys = ['productCode', 'variantCode', 'price']
          return this.checkAndTransformKeys(variants, requiredKeys, renameKeys)
        })
        .then((res) => {
          if (res.errors.length) {
            this.variantErrors = res.errors.slice(0, 10)
            this.variantAdditionalErrorsCount = res.errors.length - 10
            return null
          } else {
            this.variantErrors = []
            this.variantAdditionalErrorsCount = 0
            return res.items
          }
        })
        .then((variants) => {
          const variantsObj = {}
          variants.forEach((variant) => {
            variant.volumeCl = (variant.volumeCl || '0cl').toLowerCase()
            variant.volumeCl = variant.volumeCl.endsWith('cl')
              ? parseInt(variant.volumeCl)
              : variant.volumeCl.endsWith('l')
                ? parseInt(variant.volumeCl) * 100
                : 0

            variant.age = parseInt(variant.age) || null
            variant.alcoholContent = parseInt(variant.alcoholContent) || null
            if (this.newProducts[variant.productCode]) {
              variantsObj[variant.productCode]
                = variantsObj[variant.productCode] || []
              variantsObj[variant.productCode].push(variant)
            }
          })
          return variantsObj
        })
        .catch(() => {
          return null
        })
    },
    checkAndTransformKeys (array, requiredKeys, renameKeys) {
      let errors = []
      let items = array.map((item, index) => {
        renameKeys.forEach((key) => {
          const val = item[key[0]]
          delete item[key[0]]
          item[key[1]] = val
        })

        let missingKeys = []

        const itemValid = requiredKeys.every((key, index) => {
          if (!item[key]) {
            missingKeys.push(key)
            return false
          } else {
            return true
          }
        })

        if (!itemValid) {
          errors.push({
            index: index,
            errors: missingKeys
          })
        }

        return itemValid ? item : null
      })

      return { errors: errors, items: items }
    },
    onRemoveProduct (productCode, index) {
      this.queuedProducts.splice(index, 1)

      if (this.photos) {
        const variants = this.variants[productCode] || []
        variants.forEach((variant) => {
          delete this.photos[variant.variantCode]
        })
      }

      delete this.newProducts[productCode]
      delete this.variants[productCode]

      if (!Object.keys(this.newProducts).length) {
        this.reset()
      }
    },
    reset () {
      this.newProducts = null
      this.variants = null
      this.invalidProductPhotos = null
      this.workbook = null
      this.photos = null
      this.queuedProducts = null
      $('#products-spreadsheet').val(null)
      $('#products-photos').val(null)
      $('.file-path').val(null)
      $('.stepper').openStep(1)
      $('.done').removeClass('done')
    },
    reviewProducts () {
      this.queuedProducts = []
      this.productCodes = Object.keys(this.newProducts)
      this.totalPage = Math.ceil(this.productCodes.length / this.PAGE_LIMIT)
      const watcher = scrollmonitor.create(this.$refs.uploadBtn)
      this.currentPage = 0
      watcher.enterViewport(() => {
        this.nextPage()
      })
      $('.stepper').nextStep()
      this.nextPage()
    },
    nextPage () {
      if (this.currentPage + 1 <= this.totalPage) {
        this.isLoading = true
        this.showProducts(
          this.productCodes.slice(
            this.currentPage * this.PAGE_LIMIT,
            this.currentPage * this.PAGE_LIMIT + this.PAGE_LIMIT
          )
        ).then(() => {
          this.isLoading = false
        })
        this.currentPage++
      }
    },
    showProducts (productCodes) {
      const products = productCodes.map(async (key) => {
        const product = this.newProducts[key]
        const variants = this.variants[key]
        product.variants = variants.map((variant) => {
          variant.photo = (this.photos || {})[variant.variantCode]
          return variant
        })

        return product
      })

      return Promise.each(products, (product) => {
        this.queuedProducts.push(product)
      })
    }
  },
  components: {
    AppCardProduct
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-products-upload.vue